module.exports = "/remote-dist/f95ec0b8b06d06e53b75fb8d877776a9.png";